import React from 'react'
import {Box, Typography, Divider} from '@mui/material'
import {Link} from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'
import LaunchIcon from '@mui/icons-material/Launch'

const linkSx = {
  color: '#9ca3af',
  textDecoration: 'none',
  fontSize: '0.75rem',
  fontWeight: 500,
  fontFamily: 'Poppins, sans-serif',
  transition: 'color 0.15s',
  '&:hover': {color: '#3783e7'},
}

const Footer = () => (
  <Box sx={{width: '100%', maxWidth: 400, mt: 'auto', pt: 3}}>
    <Divider sx={{borderColor: '#e5e7eb', mb: 2}} />

    {/* Links row */}
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: 0.5, mb: 1.5}}>
      {[
        {text: 'Terms & Conditions', path: '/toc'},
        {text: 'Privacy Policy', path: '/privacy-policy'},
        {text: 'Refund Policy', path: '/refund_cancellation-policy'},
      ].map((link, i) => (
        <React.Fragment key={link.path}>
          {i > 0 && <Typography sx={{color: '#d1d5db', mx: 0.5, fontSize: '0.7rem'}}>·</Typography>}
          <Box component={Link} to={link.path} target='_blank' rel='noopener noreferrer' sx={linkSx}>
            {link.text}
          </Box>
        </React.Fragment>
      ))}
    </Box>

    {/* Contact + About row */}
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 1}}>
      <Box component='a' href='tel:+919311847248' sx={{...linkSx, display: 'flex', alignItems: 'center', gap: 0.5}}>
        <PhoneIcon sx={{fontSize: 13, color: '#9ca3af'}} />
        +91 9311847248
      </Box>
      <Box component='a' href='https://www.prozo.com/' target='_blank' rel='noopener noreferrer' sx={{...linkSx, display: 'flex', alignItems: 'center', gap: 0.3}}>
        About Prozo
        <LaunchIcon sx={{fontSize: 11}} />
      </Box>
    </Box>

    {/* Powered by */}
    <Typography sx={{textAlign: 'center', fontSize: '0.7rem', color: '#d1d5db', fontFamily: 'Poppins, sans-serif'}}>
      Powered by Prozo Supply Chain Solutions
    </Typography>
  </Box>
)

export default Footer
